import { create } from 'zustand';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const useAuthStore = create((set, get) => ({
  user: JSON.parse(localStorage.getItem('user') || 'null'),
  token: localStorage.getItem('token'),
  isAuthenticated: !!localStorage.getItem('token'),

  login: async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    const { token, user } = res.data;
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    set({ user, token, isAuthenticated: true });
    return user;
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    set({ user: null, token: null, isAuthenticated: false });
  },

  isAdmin: () => get().user?.role === 'CENTRAL_ADMIN',
}));

export const useAppStore = create((set) => ({
  stats: null,
  instances: [],
  templates: [],
  periods: [],
  units: [],
  users: [],
  loading: false,

  setLoading: (v) => set({ loading: v }),

  fetchStats: async () => {
    const res = await api.get('/dashboard/stats');
    set({ stats: res.data });
  },

  fetchInstances: async (params) => {
    const res = await api.get('/instances', { params });
    set({ instances: res.data });
  },

  fetchTemplates: async (showArchived = false, deletionStatus = null) => {
    const params = {};
    if (deletionStatus) params.deletion_status = deletionStatus;
    else if (showArchived) params.show_archived = true;
    const res = await api.get('/templates', { params });
    set({ templates: res.data });
  },

  fetchPeriods: async () => {
    const res = await api.get('/periods');
    set({ periods: res.data });
  },

  fetchUnits: async (includeArchived = false, deletionStatus = null) => {
    const params = {};
    if (deletionStatus) params.deletion_status = deletionStatus;
    else if (includeArchived) params.include_archived = true;
    const res = await api.get('/units', { params });
    set({ units: res.data });
  },

  fetchUsers: async () => {
    const res = await api.get('/users');
    set({ users: res.data });
  },
}));
